import React from "react";
import {Link} from "react-router-dom";
import pageList from './pageList';
import Request, {CODES} from '../../utils/Request';
import {RegisterStock} from '../../utils/svgs';
import {translateStatus} from '../../utils/translations'

import UserContext from '../../utils/UserContext';
import {PERMISSIONS} from '../../utils/Request';


class pageListOrdersPending extends pageList {
	
	constructor(props){
		super(props)

		this.apiName = 'orders';
		this.listSlug = 'orders';
		this.singleItem = 'pedido'; //Name of a single list item
		this.listTitle = 'Pedidos pendientes';
		
		this.itemLinkSlug = 'pedidos';

		// this.hasRowOptions = false;

		this.addPendingOrder = this.addPendingOrder.bind(this);

	}
	
	componentDidMount(){
		this.requestPages();
	}


	getTable(pages){
		let table = {};
		table.headers = [
			{
				slug: 'store',
				name: 'Tienda',
				class: 'item-medium',
				canSearch: true,
			},
			{
				slug: 'order_number',
				name: 'Nº Pedido',
				class: 'item-small',
				canSearch: true,
			},
			{
				slug: 'date',
				name: 'Fecha',
				class: 'item-medium',
			},
			{
				slug: 'status',
				name: 'Estado',
				class: 'item-medium',
				canSort: true,
				sortType: 'string',
			},
		];
		table.rows = [];
		for(let i = 0; i < pages.length; i++){
			table.rows.push(this.createRow(pages[i]));
		}
		return table;
	}

	createRow(page){
		return {
			item : page,
			store : page.store,
			order_number : page.order_number,
			date : new Date(page.time).toLocaleString(),
			status : translateStatus(page.status),
		};
	}

	renderDeleteIcon(row, index){
		return (
			<div onClick={()=>window.location='/remove-stock-pedido/'+row.item.id} title="Registrar pedido" className="icon-container font-right">
				<RegisterStock/>
			</div>
		);
		
	}


	addPendingOrder(){
		if(!this.adding){
			this.adding=true;
			let albaran = window.prompt("Introduce el número de albaran:");
			if(!albaran){
				this.adding = false;
			}else{
				Request.postAuth('/api/orders/add/', {albaran})
					.then(json => {
						this.adding = false;
						window.alert(json.message);
					 	if( json.code === CODES.success ){
					 		window.location.reload();
						}
				});
			}
		}
	}
	
	renderAddNew(){
		return <UserContext.Consumer>
				{user => {
					if(PERMISSIONS.canAdministrator(user)){
						return (
							<button onClick={this.addPendingOrder} className="button button-default font-p font-white font-center">Añadir pedido</button>
						)
					}
				}}
			</UserContext.Consumer>
	}
	
}





export default pageListOrdersPending;




